import React from "react"
import styled from "styled-components"
import Link from "next/link"
import colors from "@constants/colors"
import { bodyBold } from "@constants/typography"
import MaxWidthContainer from "@components/Layout/MaxWidthContainer"
import MaxWidthContent from "@components/Layout/MaxWidthContent"
import { Chevron } from "@components/icons"
import { IconWrapper } from "@components/icons/utils"
import { MobileOnly } from "@utils/MediaQueries"

const Container = styled.div`
  flex-wrap: wrap;
  align-items: center;
  display: flex;
`

const LinkWrapper = styled.div`
  flex-shrink: 0;
  align-items: center;
  display: flex;

  &:hover {
    cursor: pointer;
  }

  ${IconWrapper} {
    transform: rotate(90deg);
    margin-right: 2px;
  }
`

const Text = styled.div`
  ${bodyBold}
  margin-right: 6px;
  color: ${colors.slateDark};

  &.grayed {
    color: ${colors.mediumGray};
    cursor: default;
  }
`

interface BreadcrumbsProps {
  breadcrumbs: Array<{
    link: string
    label: string
  }>
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs }) => {
  return (
    <MobileOnly>
      <MaxWidthContainer>
        <MaxWidthContent cols={12}>
          <Container>
            {breadcrumbs &&
              breadcrumbs.map(({ link, label }) => (
                <LinkWrapper key={link}>
                  <IconWrapper>
                    <Chevron strokeColor={colors.slateLight} />
                  </IconWrapper>
                  {link != "#" ? (
                    <Link href={link} passHref>
                      <Text>{label}</Text>
                    </Link>
                  ) : (
                    <Text className="grayed">{label}</Text>
                  )}
                </LinkWrapper>
              ))}
          </Container>
        </MaxWidthContent>
      </MaxWidthContainer>
    </MobileOnly>
  )
}

export default Breadcrumbs
